import { render, staticRenderFns } from "./IconWebsite.vue?vue&type=template&id=2b38cc27&"
import script from "./IconWebsite.vue?vue&type=script&lang=js&"
export * from "./IconWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports